(function () {
  'use strict';

  const TAG = 'uwe-product-card';
  if (!window.customElements || customElements.get(TAG)) return;

  const CSS = `
uwe-product-card.comic-product-card{
  display:block;
  min-width:0;
  height:100%;
}

.comic-product-card__shell{
  display:grid;
  grid-template-rows:auto auto;
  gap:10px;
  height:100%;
  padding:12px;

  border-radius:18px;
  border:1px solid var(--border);
  background:color-mix(in srgb, var(--surface) 92%, transparent);
  color:var(--text);
  box-shadow:var(--shadow-sm);

  transition:transform 120ms ease, border-color 120ms ease, box-shadow 120ms ease, background 120ms ease;
}

.comic-product-card__shell:hover{
  transform:translateY(-2px);
  border-color:color-mix(in srgb, var(--accent) 48%, var(--border));
  background:color-mix(in srgb, var(--surface) 96%, var(--accent));
  box-shadow:var(--shadow-md);
}

.comic-product-card__link{
  display:grid;
  grid-template-rows:auto 1fr;
  gap:11px;
  min-width:0;
  color:var(--text);
  text-decoration:none;
}

.comic-product-card__link:hover{
  text-decoration:none;
}

.comic-product-card__media{
  width:min(100%, 150px);
  margin-inline:auto;

  display:flex;
  align-items:flex-start;
  justify-content:center;

  background:transparent;
  border:0;
  overflow:visible;
}

.comic-product-card__image{
  display:block;
  width:100%;
  height:auto;
  max-width:100%;

  border-radius:3px;
  object-fit:contain;
  object-position:center;
}

.comic-product-card__placeholder{
  width:120px;
  aspect-ratio:1;
  margin:20px auto;

  display:grid;
  place-items:center;

  border-radius:999px;
  background:color-mix(in srgb, var(--accent) 28%, var(--border));
  color:color-mix(in srgb, var(--text) 70%, transparent);

  font-size:12px;
  font-weight:950;
  text-transform:uppercase;
  letter-spacing:.08em;
}

.comic-product-card__body{
  min-width:0;
  display:flex;
  flex-direction:column;
  gap:9px;
}

.comic-product-card__title{
  margin:0;

  color:var(--text);
  font-size:15px;
  font-weight:1000;
  line-height:1.16;
  letter-spacing:-.018em;

  display:-webkit-box;
  -webkit-line-clamp:3;
  -webkit-box-orient:vertical;
  overflow:hidden;
}

.comic-product-card__chips{
  display:flex;
  flex-wrap:wrap;
  gap:5px;
  margin-top:auto;
}

.comic-product-card__chip{
  display:inline-flex;
  align-items:center;
  max-width:100%;

  padding:5px 8px;
  border-radius:999px;
  border:1px solid color-mix(in srgb, var(--border) 75%, transparent);
  background:color-mix(in srgb, var(--bg) 76%, transparent);

  color:color-mix(in srgb, var(--text) 88%, var(--muted));
  font-size:11px;
  font-weight:900;
  line-height:1;

  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
}

.comic-product-card__chip--price{
  color:#111;
  background:var(--accent);
  border-color:color-mix(in srgb, var(--accent) 55%, var(--border));
}

.comic-product-card__chip--sold{
  opacity:.58;
}

.comic-product-card__purchase{
  display:grid;
  gap:6px;
  align-self:end;
}

.comic-product-card__cartStatus{
  color:var(--muted);
  font-size:11px;
  font-weight:850;
  line-height:1.2;
  min-height:13px;
}

.comic-product-card__button{
  display:inline-flex;
  align-items:center;
  justify-content:center;
  width:100%;
  min-height:34px;
  padding:0 10px;

  cursor:pointer;
  border-radius:12px;
  border:1px solid color-mix(in srgb, var(--accent) 58%, var(--border));
  background:var(--accent);
  color:#111;

  font-size:12px;
  font-weight:1000;
  line-height:1;
  text-decoration:none;
  box-shadow:var(--shadow-sm);
  transition:transform 120ms ease, box-shadow 120ms ease, opacity 120ms ease;
}

.comic-product-card__button:hover{
  transform:translateY(-1px);
  text-decoration:none;
  box-shadow:var(--shadow-md);
}

.comic-product-card__button--secondary{
  border-color:var(--border);
  background:color-mix(in srgb, var(--surface) 92%, transparent);
  color:var(--text);
}

.comic-product-card__button[disabled]{
  cursor:not-allowed;
  opacity:.58;
  transform:none;
  box-shadow:var(--shadow-sm);
}

.comic-product-card__message{
  min-height:12px;
  color:var(--muted);
  font-size:10px;
  font-weight:850;
  line-height:1.2;
}

.comic-product-card__message.is-success{
  color:color-mix(in srgb, var(--text) 74%, #167a3a);
}

.comic-product-card__message.is-error{
  color:#b42318;
}

@media (min-width:760px){
  .comic-product-card__media{
    width:min(100%, 160px);
  }
}
`;

  let cssInjected = false;
  let cartPromise = null;
  let cartData = null;
  const instances = new Set();

  function injectCss() {
    if (cssInjected) return;
    cssInjected = true;

    const style = document.createElement('style');
    style.setAttribute('data-uwe-product-card-css', 'true');
    style.textContent = CSS;
    document.head.appendChild(style);
  }

  async function loadCart() {
    if (cartPromise) return cartPromise;

    cartPromise = fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then((response) => {
        if (!response.ok) throw new Error('Could not load cart.');
        return response.json();
      })
      .then((cart) => {
        cartData = cart;
        return cart;
      })
      .finally(() => {
        cartPromise = null;
      });

    return cartPromise;
  }

  function setCart(cart) {
    cartData = cart;
    instances.forEach((instance) => instance.updateFromCart(cartData));
  }

  function getCartQuantityForVariant(cart, variantId) {
    if (!cart || !Array.isArray(cart.items)) return 0;

    const id = String(variantId || '');
    if (!id) return 0;

    return cart.items
      .filter((item) => String(item.variant_id) === id || String(item.id) === id)
      .reduce((sum, item) => sum + Number(item.quantity || 0), 0);
  }

  class UweProductCard extends HTMLElement {
    constructor() {
      super();

      this.variantId = '';
      this.available = false;
      this.inventoryQuantity = null;
      this.inventoryManagement = '';
      this.inventoryPolicy = '';

      this.button = null;
      this.status = null;
      this.message = null;

      this.onClick = this.onClick.bind(this);
      this.onDocumentCartUpdated = this.onDocumentCartUpdated.bind(this);
    }

    connectedCallback() {
      injectCss();

      this.variantId = String(this.getAttribute('data-variant-id') || '');
      this.available = this.getAttribute('data-variant-available') === 'true';
      this.inventoryManagement = String(this.getAttribute('data-inventory-management') || '');
      this.inventoryPolicy = String(this.getAttribute('data-inventory-policy') || '');

      const rawInventoryQuantity = Number(this.getAttribute('data-inventory-quantity'));
      this.inventoryQuantity = Number.isFinite(rawInventoryQuantity) ? rawInventoryQuantity : null;

      this.button = this.querySelector('[data-product-card-add]');
      this.status = this.querySelector('[data-product-card-cart-status]');
      this.message = this.querySelector('[data-product-card-message]');

      this.addEventListener('click', this.onClick);
      document.addEventListener('cart:updated', this.onDocumentCartUpdated);
      instances.add(this);

      if (cartData) {
        this.updateFromCart(cartData);
      } else {
        loadCart()
          .then((cart) => this.updateFromCart(cart))
          .catch(() => this.updateFromCart(null));
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      document.removeEventListener('cart:updated', this.onDocumentCartUpdated);
      instances.delete(this);
    }

    tracksInventory() {
      return Boolean(this.inventoryManagement) && this.inventoryPolicy !== 'continue';
    }

    getInCart(cart) {
      return getCartQuantityForVariant(cart, this.variantId);
    }

    getRemaining(cart) {
      if (!this.available) return 0;
      if (!this.tracksInventory()) return null;

      const inventory = Math.max(0, Number(this.inventoryQuantity || 0));
      return Math.max(0, inventory - this.getInCart(cart));
    }

    setMessage(text, type) {
      if (!this.message) return;

      this.message.textContent = text || '';
      this.message.classList.remove('is-success', 'is-error');

      if (type) {
        this.message.classList.add(type === 'error' ? 'is-error' : 'is-success');
      }
    }

    setLoading(isLoading) {
      if (!this.button) return;

      if (isLoading) {
        this.button.disabled = true;
        this.button.textContent = 'Adding...';
      } else {
        this.updateFromCart(cartData);
      }
    }

    updateFromCart(cart) {
      const inCart = this.getInCart(cart);
      const remaining = this.getRemaining(cart);
      const canAdd = this.available && (remaining === null || remaining > 0);

      if (this.status) {
        if (inCart > 0) {
          this.status.hidden = false;
          this.status.textContent = inCart + ' in cart';
        } else {
          this.status.hidden = true;
          this.status.textContent = '';
        }
      }

      if (this.button) {
        this.button.disabled = !canAdd;

        if (!this.available) {
          this.button.textContent = 'Sold out';
        } else if (!canAdd) {
          this.button.textContent = 'In cart';
        } else if (inCart > 0) {
          this.button.textContent = 'Add another';
        } else {
          this.button.textContent = 'Add to Cart';
        }
      }
    }

    async addToCart() {
      if (!this.button || !this.variantId) return;

      const remaining = this.getRemaining(cartData);
      if (remaining === 0) {
        this.setMessage('Already in cart.', 'error');
        this.updateFromCart(cartData);
        return;
      }

      this.setLoading(true);
      this.setMessage('', null);

      try {
        const formData = new FormData();
        formData.append('id', this.variantId);
        formData.append('quantity', '1');

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { Accept: 'application/json' },
          credentials: 'same-origin'
        });

        const payload = await response.json().catch(() => ({}));

        if (!response.ok) {
          throw new Error(payload.description || payload.message || 'Could not add this comic to cart.');
        }

        const cart = await loadCart();
        setCart(cart);

        this.setMessage('', 'success');

        document.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { cart: cart, item: payload, source: 'product-card' }
        }));
      } catch (error) {
        this.setMessage(error.message || 'Could not add this comic to cart.', 'error');
        this.updateFromCart(cartData);
      } finally {
        this.setLoading(false);
      }
    }

    onClick(event) {
      const addButton = event.target.closest('[data-product-card-add]');
      if (!addButton) return;

      event.preventDefault();
      event.stopPropagation();

      this.addToCart();
    }

    onDocumentCartUpdated(event) {
      if (event && event.detail && event.detail.cart) {
        setCart(event.detail.cart);
        return;
      }

      loadCart()
        .then(setCart)
        .catch(() => {});
    }
  }

  customElements.define(TAG, UweProductCard);
})();
